import { defineStore } from "pinia";
import IAuthHeaderConfig from "types/AuthHeaderConfig/IAuthHeaderConfig";

interface State {
  apiAuthorizationHeader?: string | IAuthHeaderConfig;
}

export const useApiAuthHeaderStore = defineStore("apiAuthHeaderStore", {
  state: (): State => ({}),

  actions: {
    setApiAuthHeader(header: string | IAuthHeaderConfig) {
      this.apiAuthorizationHeader = header;
    },
  },
});
